<script lang="ts" setup>
import { computed } from "vue";
import { Tag } from "~/components/clarity-ui/Tag";
import CommonLabel from "~/templates/components/CommonLabel.vue";

export interface SubscriptionStatusProps {
  status: string;
}

const { status } = defineProps<SubscriptionStatusProps>();

const isCancelled = computed(() => status?.includes("cancel"));
const isPaymentUpdateRequested = computed(() => status === "payment_update_requested");
const isActive = computed(() => status === "active");
const isPaused = computed(() => status === "paused");
</script>

<template>
  <Tag v-if="isCancelled" color="cancel" outlined>
    <CommonLabel path="BWF/shop/account/subscriptions/contract/statusCancelled" />
  </Tag>
  <Tag v-else-if="isPaymentUpdateRequested" color="failure" outlined>
    <CommonLabel path="BWF/shop/account/subscriptions/contract/paymentUpdateRequested" />
  </Tag>
  <Tag v-else-if="isActive" color="success" outlined>
    <CommonLabel path="BWF/shop/account/subscriptions/contract/statusActive" />
  </Tag>
  <Tag v-else-if="isPaused" outlined>
    <CommonLabel path="BWF/shop/account/subscriptions/contract/statusPaused" />
  </Tag>
</template>
